import styled from 'styled-components';

const IconSelectedStyled = styled.svg`
  background: rgba(255, 255, 255, 0.7);
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.2);
  border: 5px solid ${props => props.theme.colors.white};
  border-radius: 100%;
  fill: ${props => props.theme.colors.dark};
  height: 20px;
  left: 50%;
  opacity: ${props => (props.selected ? '0.75' : '0')};
  padding: 5px;
  position: absolute;
  top: 50%;
  transform: ${props =>
    props.selected
      ? 'translate(-50%, -50%) scale(1)'
      : 'translate(-50%, -50%) scale(0)'};
  transition: transform ${props => props.theme.transition.duration}
      ${props => props.theme.transition.easeInOut},
    opacity ${props => props.theme.transition.duration}
      ${props => props.theme.transition.easeOut};
  width: 20px;
  z-index: 10;

  @media screen and (min-width: ${props => props.theme.breakpoints.md}) {
    box-shadow: 0 4px 0 rgba(0, 0, 0, 0.2);
    height: 25px;
    padding: 10px;
    width: 25px;
  }

  path {
    transform: translateY(10px);
  }
`;

export default IconSelectedStyled;



// WEBPACK FOOTER //
// ./src/components/atoms/IconSelected/IconSelected.styled.js